import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import thematize from 'lib/thematize';
import Text from 'components/Base/Text';
import messages from './messages';
import styles from './Reset.scss';

const theme = thematize(styles);

interface Props {
  onReset: () => void;
}
const Reset = ({ onReset }: Props): React.ReactElement => (
  <div onClick={onReset} className={theme('container')}>
    <Text className={theme('reset')}>
      <FormattedMessage {...messages.reset} />
    </Text>
  </div>
);

export default Reset;
